import request from '@/utils/request'
const apiPath = '/sys/user'
const userApi = {
  /**
   * 新增【用户】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【用户】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【用户】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  fetchListForMini(query) {
    return request.get(apiPath + '/tee/listForMini', { params: query })
  },
  /**
   * 查看【用户】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 查看【用户】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 修改【用户】入职离职
   */
  updateJobStatus(data) {
    return request.post(`${apiPath}/updateJobStatus`, data)
  },
  /**
   * 删除单个【用户】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  /**
   * 批量删除【用户】
   */
  deleteBatch(ids) {
    return request.delete(apiPath, { data: ids })
  },
  getCaptcha(query) {
    return request.get(apiPath + '/getCaptcha', { params: query })
  },
  // 修改禁用启用登录
  updateEntryInhibited(data) {
    return request.post(apiPath + '/updateEntryInhibited', data)
  },
  getMsgCode(data) {
    return request.post(apiPath + '/getMsgCode', data, { isFormData: 1 })
  },
  loginUpdatePassWord(data) {
    return request.post(apiPath + '/loginUpdatePassWord', data)
  },
  delCache(query) {
    return request.get(apiPath + '/delCache', { params: query })
  },
}
export default userApi
